/**
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
import { Component } from '@angular/core';
import { ButtonSize, ButtonStyle } from '../../../aero/aero-button/aero-button.component';

@Component({
  selector: 'bulb-button-styles',
  templateUrl: './button-styles.component.html',
  styleUrls: ['./button-styles.component.scss'],
  standalone: false,
})
export class ButtonStylesComponent {
  /**
   * Reference to the ButtonSize enum
   */
  public ButtonSize = ButtonSize;

  /**
   * Reference to the ButtonStyle enum
   */
  public ButtonStyle = ButtonStyle;
}
